export default __webpack_public_path__ + "static/GRID22-how-to-read-data-disasters-fr-8785810a068e3583ae5bad5a4408439e.png";